import React, {Component} from 'react'
import Registry from "../../../registry";

class ChatLogCGU extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 0
        }
    }

    render() {

        let lang = Registry.get('locale');
        let browser = this.props.browser;

        const tabs = [1, 2, 3, 4];

        return (
            <div className="message chatlog-cgu">
                <p className="title" dangerouslySetInnerHTML={{__html: lang.cgu_title}} />
                <p className="desc" dangerouslySetInnerHTML={{__html: lang.cgu_desc}} />

                <div className="cgu">
                    {tabs.map((tabNumber, index) => {
                        return <div key={index}>
                            <h3 className={this.state.activeTab === tabNumber ? "active" : null} onClick={() => { if(this.state.activeTab !== tabNumber) this.setState({activeTab : tabNumber}); else this.setState({activeTab : 0}); } }>{lang['cgu_head_' + tabNumber]}</h3>
                            {browser.mobile && this.state.activeTab === tabNumber
                                ? <ul dangerouslySetInnerHTML={{__html: lang['cgu_text_' + this.state.activeTab]}} />
                                : null}
                        </div>
                    })}
                </div>

                {browser.desktop && this.state.activeTab
                    ? <ul dangerouslySetInnerHTML={{__html: lang['cgu_text_' + this.state.activeTab]}} />
                    : null}

                <p className="good-chat">{lang.cgu_good_chat}</p>

                <div className="info-room">
                    <div className="os">
                        <div className="ic_windows" title="Windows"></div>
                        <div className="ic_macOSX" title="Mac OS X"></div>
                        <div className="ic_android" title="Android"></div>
                        <div className="ic_iOS" title="iOS"></div>
                    </div>
                    <div className="browser">
                        <div className="ic_googleChrome" title="Google Chrome"></div>
                        <div className="ic_firefox" title="Mozilla Firefox"></div>
                        <div className="ic_opera" title="Opera"></div>
                        <div className="ic_safari" title="Safari"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChatLogCGU;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogCGU/index.js